import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "solutions",
  class: "bg-everWhite"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center md:text-48px text-2xl font-inter-bold" }, " Solutions We Offer ", -1)
const _hoisted_3 = { class: "px-5" }
const _hoisted_4 = { class: "max-w-588px w-full text-everBlack md:mr-6" }
const _hoisted_5 = { class: "md:text-32px text-xl font-inter-semiBold" }
const _hoisted_6 = { class: "md:text-2xl text-base mt-2 text-everBlack1" }
const _hoisted_7 = { class: "opacity-65 mt-6 text-14px md:text-base" }
const _hoisted_8 = { class: "flex mt-6" }
const _hoisted_9 = ["src"]

import Container from './Container.vue'
import BtnArea from './BtnArea.vue'
interface JumpLink{
  title: string
  href: string
  bgBlue?: boolean
}
interface SolutionsList {
  msg1: string
  msg2: string
  msg3: string
  jumpLink: JumpLink[]
  imgSrc: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsWeOffer',
  setup(__props) {

const solutionsList:SolutionsList[] = [
  {
    msg1: 'A different way to pay',
    msg2: 'everPay: a real-time payment protocol with 0 gas fees',
    msg3: 'Following the creation of SCP, we’ve also made it possible to connect to 6 public chains along with their assets, more public chains to come in the future. everPay can be integrated into any product or platform; this will allow them to have the capacity to pay with crypto; all you’d need to do is simply use our everpay.js.',
    jumpLink: [
      {
        title: 'Launch APP',
        bgBlue: true,
        href: 'https://app.everpay.io/'
      },
      {
        title: 'Document',
        href: 'https://docs.everpay.io/en/'
      }
    ],
    imgSrc: 'solutions_1.png'
  },
  {
    msg1: 'A DEX like no other',
    msg2: 'Permaswap: A real-time cross-chain DEX network with 0 gas fees.',
    msg3: '0% front running slippage with 100% permanence. We bring you a peer-to-peer DEX network powered by everPay. This brings valuable liquidity to the Arweave ecosystem and enables you to exchange your assets from the 6 public chains we support all in one place.',
    jumpLink: [
      {
        title: 'Launch APP ',
        bgBlue: true,
        href: 'https://permaswap.network/'
      },
      {
        title: 'Whitepaper',
        href: 'https://mirror.xyz/permaswap.eth/ustZcDgavlm4xmYI26thEAj8W2cXlZpRkG5Jqz0iS14'
      }
    ],
    imgSrc: 'solutions_2.png'
  },
  {
    msg1: 'Easy dev tools',
    msg2: 'Web3Infra: An open-source development tool for Arweave',
    msg3: 'A developer\'s best friend, easy-to-use all whilst being a high-performing development tool that includes an Arweave light node service called Arseeding along with other services such as Goar, Arsyncer, and Turing. We\'ll, later on, add more open-source tools. Come and build on Web3 easily with no headaches.',
    jumpLink: [
      {
        title: 'BuidL now',
        href: 'https://web3infra.dev/'
      }
    ],
    imgSrc: 'solutions_3.png'
  },
  {
    msg1: 'Contribute to Arweave',
    msg2: 'PermaDAO: An Arweave ecosystem DAO',
    msg3: 'We’re focusing on Arweave’s ecosystem and exploring new ways of Web3 collaborations. We use Notion, everPay, and Permaswap to create a highly transparent workflow.',
    jumpLink: [
      {
        title: 'Join us',
        href: 'https://permadao.com/'
      }
    ],
    imgSrc: 'solutions_4.png'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Container, { class: "md:py-36 py-12" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solutionsList, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass([ index % 2 ? 'flex-row-reverse' : 'flex-row', "md:flex justify-between items-center md:mt-36 mt-12"]),
              style: {"min-height":"400px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.msg1), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.msg2), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.msg3), 1),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.jumpLink, (jump, jumpIndex) => {
                    return (_openBlock(), _createBlock(BtnArea, {
                      key: jumpIndex,
                      href: jump.href,
                      class: _normalizeClass([jump.bgBlue ? 'bg-everBlue2 text-white' : 'text-everBlue2 border-everBlue1', "mr-6"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(jump.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "class"]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["max-w-588px w-full flex justify-center md:px-0 px-9 md:py-0 py-12", index % 2 ? 'md:justify-start md:mr-6' : 'md:justify-end'])
              }, [
                _createElementVNode("img", {
                  src: require(`@/images/${item.imgSrc}`),
                  class: "max-h-400px md:w-392px",
                  alt: "everVision description"
                }, null, 8, _hoisted_9)
              ], 2)
            ], 2)
          }), 64))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})